export default __webpack_public_path__ + "static/media/20-4.40ec6f66.mp3";